export class Duration {
  secs: number;
  nanos: number;

  constructor(json: any) {
    this.secs = Number(json.secs);
    this.nanos = Number(json.nanos);
  }
}
